<template>
    <div>
        <div id="dbRecords" >

          <div v-if="tab_name == 'mentors'">
             <div class="row">
               <div class="col-6 db_name_block">
                  <span class="title">{{ card_title }} <span style="font-weight: bold;">({{ count }})</span></span>
                </div>
                <div class="col-3 panel-heading-bold">Mentees</div>
                <div class="col-3 text-right">
                   <button type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="openAddMentorModal('mentor')" style="text-decoration: none !important; text-align: right; font-size: 16px; padding-right: 0;">Add Mentor</button>
                </div>
              </div>          
            
                      <div class="col-12 mt-2 db-empty-card"  v-if="count == 0">
                        <div >
                          <h6 class="empty-content-title">No Mentors Found. Let's add one!</h6>
                          <button type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="openAddMentorModal('mentor')" style="text-decoration: none !important; font-size: 16px; padding-right: 0;">Add Mentor</button>
                        </div>
                      </div>

            <div class="col-12 p-0">
                <div v-for="(item, lindex) in allItems" :key="lindex" class="mentor-row">
                  <div class="row">
                    <div class="col-6 db_name_block" style="cursor: pointer;" @click="openEditUserModal('mentor', item.id)">
                       <div class="db-mentee-name">{{item.first_name + ' ' + item.last_name}}</div>
                        <div class="db-mentee-email">{{ item.email }}</div>
                    </div>
                   <div class="col-3 mentee-count-info">{{ item.mentees_count }}</div>
                   <div class="col-3 inactive-link" v-if="item.status=='Active'" @click="inactivateUserConfirm(item)">Inactivate</div>
                   <div class="col-3 active-link" v-else @click="activateUserConfirm(item.id, item.first_name, item.last_name)">Activate</div>
                  </div>
                </div>
           </div>
         </div>

         <div v-if="tab_name == 'managers'">
             <div class="row">
               <div class="col-7 db_name_block">
                  <span class="title">{{ card_title }} <span style="font-weight: bold;">({{ count }})</span></span>
                </div>
                <div class="col-5 text-right">
                   <button type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="openAddMentorModal('manager')" style="text-decoration: none !important; text-align: right; font-size: 16px; padding-right: 0;">Add Manager</button>
                </div>
              </div>          
            
                      <div class="col-12 mt-2 db-empty-card" v-if="count == 0">
                        <div >
                          <h6 class="empty-content-title">No Managers Found. Let's add one!</h6>
                          <button type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="openAddMentorModal('manager')" style="text-decoration: none !important; font-size: 16px; padding-right: 0;">Add Manager</button>
                        </div>
                      </div>
            <div class="col-12 p-0">
                <div v-for="(item, lindex) in allItems" :key="lindex" class="mentor-row">
                  <div class="row">
                    <div class="col-7 db_name_block" style="cursor: pointer;" @click="openEditUserModal('manager', item.id)">
                        <div class="db-mentee-name" v-if="isBrandingFlag == 1">
                          {{item.first_name + ' ' + item.last_name}} 
                          <span v-if="item.is_primary_admin" class="badge badge-info text-uppercase admin-console-badge">Primary</span>
                          <span v-if="item.is_billing_admin && !item.is_primary_admin" class="badge badge-info text-uppercase admin-console-badge">Billing</span>                          
                        </div>
                        <div class="db-mentee-name" v-else-if="isBrandingFlag === 0">
                          {{item.first_name + ' ' + item.last_name}} 
                          <span v-if="item.is_primary_admin" class="badge badge-info text-uppercase" style="background-color: #4088bd;">Primary</span>
                          <span v-if="item.is_billing_admin && !item.is_primary_admin" class="badge badge-info text-uppercase" style="background-color: #4088bd;">Billing</span>                          
                        </div>
                        <div class="db-mentee-email">{{ item.email }}</div>
                    </div>
                   <div class="col-5 text-right inactive-link" style=""
                     v-if="((item.status=='Active') && (item.is_primary_admin))" @click="inactivatePrimaryUserConfirm(item)">
                     Inactivate
                   </div>
                   <div class="col-5 text-right inactive-link" style=""
                     v-else-if="(item.status=='Active')" @click="inactivateUserConfirm(item)">
                     Inactivate
                   </div>


                   <div class="col-5 text-right active-link" v-else @click="activateUserConfirm(item.id, item.first_name, item.last_name)">Activate</div>
                  </div>
                </div>
           </div>
         </div>          

       </div>


    </div>
</template>
<script>

import router from '../../router/index.js';
import Avatar from 'vue-avatar';
import axios from 'axios';
import { store } from '../../store/store';
import MenteeReviewRepetition from './MenteeReviewRepetitionAllTasklists.vue';
import UserAssessmentDetails from './UserAssessmentDetailsModal.vue';
import UserCourseDetails from './UserCourseDetailsModal.vue';

export default {
    props: [
        'card_title', 
        'count', 
        'show_more', 
        'itemLength',
        'lessResult', 
        'allItems', 
        'btnName',
        'btnLink',
        'btnType',
        'isListType',
        'see_more_text',
        'tab_name'
    ],
    data: function () {
        return {
            customStyle: {
              'font-size': '16px',
              'font-weight': 'bold',

            },
            assessment_loading: false,
            assessmentCourses: [],
            mentor_assessment_loading: false,
            mentor_assessmentCourses: [],
            repCount: '',
            isReviewRepsModalVisible: false,
            menteeId: '',
            menteeIndex: '',
            loading: false,
            mentor_loading: false,
            isUserAssessmentModalVisible: false,
            assessmentId: '',
            assessmentMenteeId: '',
            courseId: '',
            isUserCourseModalVisible: false,
            courseMenteeId: '',
            name: '',
            isBrandingFlag: '',
        }
    },        
    created() {
      if(this.$store.state.user_accountid) {
      axios('/desktop/get-account-color-code-logo/' + this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(resp => {
        if(resp.data.logoName) {
            this.isBrandingFlag = 1;
        }
        else {
            this.isBrandingFlag = 0;
        }
      })
      .catch(() => {
      });
      }
    },
    methods: {
        openAddMentorModal(type) {
          this.$emit('openAddMentorModal', type);
        },
        openEditUserModal(type, id) {
          this.$emit('openEditUserModal', type, id);
        },
        inactivateUserConfirm(item) {
           this.$parent.inactivateUser(item);
        },
        inactivatePrimaryUserConfirm(item) {
          this.$parent.openUpdatePrimaryManagerModal(item);
        },  
        activateUserConfirm(id, first_name, last_name) {
           this.name = first_name + ' ' + last_name;           
           this.$parent.activateUser(id, this.name);
        },
        clickShowMore() {
          this.$emit('click');
        },
        userAssessmentModalOpen(id, menteeId, type) {
          if(type == 'Course') {
            this.isUserCourseModalVisible = true;
            this.courseId = id;
            this.courseMenteeId = menteeId;
            this.$refs.user_course_details.getUserCourseDetails(id, menteeId);
          }
          else {
            this.isUserAssessmentModalVisible = true;
            this.assessmentId = id;
            this.assessmentMenteeId = menteeId;
            this.$refs.user_assessment_details.getUserAssessmentDetails(id, menteeId);
          }
        },
        menteeRepititionApproval(id, index) {
          this.isReviewRepsModalVisible = true;
          this.menteeId = id;
          this.menteeIndex = index;
          this.repCount = this.allItems[index].rep_count;
          this.$refs.review_reps_form.getPendingReviews(this.repCount);
          this.$refs.review_reps_form.getMenteeRepetitionList(id);
          const vmessage = 'hide_vmessage';
          this.$refs.review_reps_form.getScoreLists(vmessage);
          setTimeout(()=>{
            this.isReviewRepsModalVisible = true;
            return false;
          }, 1000);
        },
        report_redirect: function(menteeId, tasklistId) {
          let routeData = this.$router.resolve({name: 'competencyreport', query: {menteeId: menteeId, tasklistId: tasklistId}});
          window.open(routeData.href, '_blank');
        },
        getSecondFontIcon(id, index, type) {
          this.assessmentCourses = [];
          if (type == "show") {
            this.allItems[index].loading = true;
            this.getAssessmentCourseDetails(id, index);
          } else {
            document.getElementById("mentee-second-up-" + id).style.display = 'none';
            document.getElementById("mentee-second-down-" + id).style.display = 'block';
            this.allItems[index].assessment_loading = false;
          }
        },
        getAssessmentCourseDetails: function(menteeId, index) {
          var id = menteeId;
          axios.get('/desktop/user/assessment-course-lists/' + this.$store.state.user_accountid + '/' + menteeId, {
          })
          .then(response =>  {
            this.allItems[index].assessment_loading = true;
            this.allItems[index].loading = false;
            this.allItems[index].assessmentCourses = response.data.assessmentCourse;
            document.getElementById("mentee-second-up-" + id).style.display = 'block';
            document.getElementById("mentee-second-down-" + id).style.display = 'none';
          })
          .catch(function() {
            console.log("Come here");
          });
        },

        getMentorSecondFontIcon(id, index, type) {
          this.mentor_assessmentCourses = [];
          if (type == "show") {
            this.allItems[index].mentor_loading = true;
            document.getElementById("mentor-assessment-" + id).style.display = 'block';
            this.getMentorAssessmentCourseDetails(id, index);
          } else {
            document.getElementById("mentor-second-up-" + id).style.display = 'none';
            document.getElementById("mentor-second-down-" + id).style.display = 'block';
            document.getElementById("mentor-assessment-" + id).style.display = 'none';
            this.allItems[index].mentor_assessment_loading = false;
          }
        },
        getMentorAssessmentCourseDetails: function(menteeId, index) {
          var id = menteeId;
          axios.get('/desktop/user/assessment-course-lists/' + this.$store.state.user_accountid + '/' + menteeId, {
          })
          .then(response =>  {
            this.allItems[index].mentor_assessmentCourses = response.data.assessmentCourse;
            this.allItems[index].mentor_loading = false;
            this.allItems[index].mentor_assessment_loading = true;
            document.getElementById("mentor-second-up-" + id).style.display = 'block';
            document.getElementById("mentor-second-down-" + id).style.display = 'none';
          })
          .catch(function() {
            console.log("Come here");
          });
        },

        getFontIcon(id, index) {
          if (document.getElementById('mentee-first-' + id).style.display == "") {
            document.getElementById('angle-'+ id).className = "fa fa-chevron-down";
            document.getElementById("mentee-second-up-" + id).style.display = 'none';
            document.getElementById("mentee-second-down-" + id).style.display = 'block';
            this.allItems[index].loading = false;
            this.allItems[index].assessmentCourses = [];
            this.allItems[index].assessment_loading = false;
          } else {
            document.getElementById('angle-'+ id).className = "fa fa-chevron-up";
            this.allItems[index].loading = false;
            this.allItems[index].assessmentCourses = [];
            this.allItems[index].assessment_loading = false;
          }
        },
        initialAvatar(firstname, lastname) {
          var initial = '';
          initial = firstname.charAt(0) + ' ' + lastname.charAt(0);
          return initial;
        },
        getMenteeProfileLink(id) {
          router.push('/view-mentee-profile/' + id);
        },
         IsUserManager() {
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_ADMIN') > -1 && (this.$store.state.switch_flag && this.$store.state.switch_flag.toLowerCase() == 'manager'))
          {
            return true;
          } else {
            if (
              this.$store.state.switch_admin_roles && 
              this.$store.state.switch_admin_roles.indexOf("ROLE_ADMIN") > -1 && 
              (this.$store.state.switch_flag 
              && this.$store.state.switch_flag.toLowerCase() == 'manager')
            ) {
              return true;
            } else {
              return false;
            }
          }
       },
       getMarginClass() {
         return (this.tab_name == 'mentees' || this.tab_name == 'apprentices') ? '' : 'marginTop20';
       }
    },
   components: {
    Avatar,
    MenteeReviewRepetition,
    UserAssessmentDetails,
    UserCourseDetails,
   },

}
</script>
<style scoped>
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.db-card .db-mentee-name {
  font-size: 14px;
  word-break: break-word;
  margin-top: 9px; 
  text-transform: capitalize;
}
.db-card .see-more, .db-card .see-more :hover{
  color: #002F42;
  font-size: 13px;
  font-weight: 600;
  float: right;
  text-decoration: none !important;
}
.circle {
  background-color: #A5A5A5;
  border-radius: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-right: 5px;
  float: left;
}
.initials {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  position: relative;
  transform: translateY(22px);
  color: #FFF;
  display: inline-block;
  vertical-align: middle;
}
.db_name_block {
  float: right;
}
.dbAddBtn, .dbEditBtn{
  border: 0px solid #29A3E4;
  background: none;
  font-size: 16px;
  font-weight: bold;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 15px;
}
.dbAddBtn:active, .dbAddBtn:focus, .dbAddBtn:hover, .dbEditBtn:focus, .dbEditBtn:hover {
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 
.dbGoalBtn {
  text-decoration: underline;
  color: #002F42 !important;
}
.marginTop20 {
  margin-top: 15px !important;
}
/* media query css start */
@media (min-width: 992px) {
  .dbAddBtn {
    width: 150px;
  }
  .dbAddBtn {
    width: 120px;
  }
}
@media (max-width: 991px) {
  .dbAddBtn {
    width: 120px;
  }
}
.goal-indicator-btn {
    border-radius: 10px;
    font-size: 13px;
    padding: 5px;
    line-height: 12px;
    height: auto;
    width: 80px;
    text-align: center;
    outline: none !important;
}
.greenBtn, .greenBtn:active, .greenBtn:focus{
    color: #FFFFFF !important;
    background-color: #68C47E !important;
    border: 1px solid #68C47E !important;
    cursor: text;
}
.progress {
  margin-top: 3px;
  border: 0px solid #FFF;
  background-color: #FFFFFF;
  height: 15px;
}
.progress-blue {
  height: 10px;
}
.progress-bar-green {
  background-color: #228B22;
}
.progress-bar-blue {
  background-color: #29A3E4;
}
.view-certificate {
    text-align: right;
    font-size: 11px;
    color: #29A3E4;
    cursor: pointer;
    text-decoration: underline !important;
}
.view-error-certificate {
  color: #EE4200;
  text-decoration: none !important;
  text-align: right;
  font-size: 11px;
}
.view-certificate a, .view-certificate a:hover{ 
  color: #29A3E4 !important;
  text-decoration: underline !important;
  font-weight: bold;
}
.mentee-first-collapse .card, .mentee-second-collapse .card {
  background: none;
  width: 100% !important;
}
.mentee-first-icon i, .mentee-second-icon i, .mentor-second-icon i {
  float: right;
  padding-right: 15px;
  font-weight: normal;
  font-size: 12px;
  color: #29A3E4 !important;
}
.mentee-second-icon i {
  float: none;
}
.mentee-first-icon i:hover, .mentee-second-icon i:hover, .mentor-second-icon i:hover {
  color: #29A3E4 !important;
}
.goReview{
  background-color: #FFF;
  border: 1px solid #29A3E4;
  border-radius: 10px;
  padding: 2px;
  line-height: 13px;
  margin: 15px 5px;
  float: right;
}
.goReviewBtn {
  text-align: right;
}
@media (max-width: 1360px) {
  .goReview {
    width: 85%;
  }
  .goReview-0 {
    width: 50%;
  }
  .goReviewBtn {
    width: 30%;
  }
}
@media (min-width: 1361px) {
  .goReview {
    width: 81%;
  }
  .goReview-0 {
    width: 45%;
  }
  .goReviewBtn {
    width: 35%;
  }
}
@media (min-width: 1680px) {
  .goReviewBtn {
    width: 35%;
  }
}
.goReview div {
  margin-left: 5px;
  float: left;
}
.review_count { 
  color: #00acee; 
  font-size: 20px; 
  margin-top: 6px; 
}
.review_text { 
  font-weight: 100;
  color: #002F42;
  text-align: left;
  font-size: 12px;
}
.goRepsBtn, .goRepsBtn:active {
  color: #FFF; 
  background-color: #EE4200 !important;
  border: 1px solid #EE4200 !important;
  border-radius: 10px;
  padding: 2px 5px;
  margin-top: 1px;
  height: 25px;
}
.mentee-first-icon .custom-remove .mentee-first-icon .custom-remove:hover {
    color: #EE4200 !important;
}
i.custom-tick, .custom-tick:hover {
    color: #19a974 !important;
}
.inactive-link {
  color: #FF0000;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: right;
  cursor: pointer;
}

.active-link {
  color: #28a745!important;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: right;
  cursor: pointer;
}
.mentor-row {
  border-bottom: 1px solid #dadce0;  
  padding: 0px 0px 7px 0px
}
.panel-heading-bold {
  font-weight: bold;
}
.mentee-count-info {
  padding-left: 30px;
  margin-top: 15px;
}
.inactive-txt {
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: right;  
}
.db-card .mentor-row:last-child  {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/db_card_list.vue